import {
	brandingOut,
	brandingOver,
	brandingUp,
	enzymeClick,
	enzymeOut,
	enzymeOver,
	featureClick,
	featureOut,
	featureOver,
	primerClick,
	primerOut,
	primerOver,
} from "../../utils/plasmid/mapSeqInteractivity";
import { ftransClick, ftransOut, ftransOver } from "../../utils/plasmid/ftrans";

function initMethods(target) {
	target.branding_over = brandingOver;
	target.branding_out = brandingOut;
	target.branding_up = brandingUp;

	target.enzyme_over = enzymeOver;
	target.enzyme_out = enzymeOut;
	target.enzyme_click = enzymeClick;

	target.feature_over = featureOver;
	target.feature_out = featureOut;
	target.feature_click = featureClick;

	target.primer_over = primerOver;
	target.primer_out = primerOut;
	target.ftrans_over = ftransOver;
	target.ftrans_out = ftransOut;
	target.ftrans_click = ftransClick;
	target.primer_click = primerClick;

	/*	target.branding_out = branding_out;
		target.query_enzyme_elements = query_enzyme_elements;
		target.set_visibility = set_visibility;
		target.query_similar_enzyme_elements = query_similar_enzyme_elements;
		target.show_tooltip_by_element = show_tooltip_by_element;
		target.find_nearest_relative_position_parent = find_nearest_relative_position_parent;
		target.get_style = get_style;
		target.getOffsetRect = getOffsetRect;
		target.hide_tooltip_by_element = hide_tooltip_by_element;
		target.query_feature_elements = query_feature_elements;
		target.find_sequence_line_number = find_sequence_line_number; */
}

function initMapSeqInteractivity() {
	if (typeof window === "undefined") return;
	if (initMapSeqInteractivity.initialized) return;
	initMethods(global.document);
	initMethods(global.window);
	initMapSeqInteractivity.initialized = true;
}

initMapSeqInteractivity.initialized = false;

export default initMapSeqInteractivity;
